<template>
  <div class="integrated">
    <div class="content">
      <ul class="ul">
        <li class="li" v-for="(item, index) in imgList" :key="index">
          <div class="img">
            <img :src="item.img" alt="" />
            <div class="layer">
              {{ item.desc }}
            </div>
          </div>
          <!-- <div class="name">
            {{ item.name }}
          </div> -->
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'integrated',
  data() {
    return {
      imgList: [
        {
          img: require('./img/222.gif'),
          name: '二三维一体化',
          desc: '通过二维数据和三维模型的组合，实现二维功能和三维效果的完美搭配应用。'
        },
        {
          img: require('./img/333.gif'),
          name: '二三维一体化',
          desc: '通过二维数据和三维模型的组合，实现二维功能和三维效果的完美搭配应用。'
        }
      ]
    };
  },
  computed: {},
  watch: {},
  methods: {},
  mounted() {}
};
</script>

<style scoped lang="scss">
@import url('~@/icons/pingfang/font.css');
.integrated {
  .content {
    width: 100%;
    min-height: 450px;
    margin: 0 auto;
    background: #ffffff;
    // border: 1px solid #979797;
    .ul {
      display: flex;
      flex-wrap: wrap;
      box-sizing: border-box;
      min-height: 850px;
      padding: 45px 240px 0 240px;
      justify-content: center;
      .li {
        margin-top: 45px;
        text-align: center;
        .img {
          margin-right: 80px;
          width: 416px;
          height: 234px;
          position: relative;
          overflow: hidden;
          cursor: pointer;
          img {
            width: 100%;
            height: 100%;
          }
          .layer {
            position: absolute;
            left: 0;
            bottom: -165px;
            width: 100%;
            height: 165px;
            transition: 0.5s;
            background: rgba(0, 0, 0, 0.6);
            color: #fff;
            font-family: 'PingFang';
            font-size: 22px;
            line-height: 30px;
            box-sizing: border-box;
            padding: 23px 58px 0 39px;
            text-align: left;
          }
        }
        .name {
          margin-top: 18px;
          font-size: 26px;
          font-family: 'PingFang';
          font-weight: bold;
          color: #000000;
        }
        // &:hover {
        //   .img {
        //     .layer {
        //       bottom: 0;
        //     }
        //   }
        // }
      }
    }
  }
}
</style>
